<template>
  <div class="office">
    <section class="office-data">
      <ul class="office-data-list">
        <li class="office-data-item icon-building">
          <a
            class="link-external"
            :href="office.official_site_url"
            target="_blank"
            v-if="office.official_site_url"
          >{{ office.office_name || '-' }}</a>
          <p v-else>{{ office.office_name || '-' }}</p>
        </li>
        <li class="office-data-item icon-pin">
          <template v-if="office.access_url">
            <a
              class="link-external"
              :href="office.access_url"
              target="_blank"
            >
            <span class="postcode" v-if="office.postcode1 || office.postcode2">
              <span>{{ office.postcode1 }}</span>
              <span>{{ office.postcode2 }}</span>
            </span>
            <span v-else>-</span>
            <br />
            <span class="address" v-if="office.state">
              {{ office.state }}{{ office.city }}{{ office.street }}
              <br v-if=" office.building_name" />
              {{ office.building_name }}
            </span>
            <span v-else>-</span>
            </a>
          </template>
          <template v-else>
            <span class="postcode" v-if="office.postcode1 || office.postcode2">
              <span>{{ office.postcode1 }}</span>
              <span>{{ office.postcode2 }}</span>
            </span>
            <span v-else>-</span>
            <br />
            <span class="address" v-if="office.state">
              {{ office.state }}{{ office.city }}{{ office.street }}
              <br />
              {{ office.building_name }}
            </span>
            <span v-else>-</span>
          </template>
        </li>
        <li class="office-data-item icon-phone">
          <PhoneNumber
            :area="office.tel_area_no || ''"
            :local="office.tel_local_no || ''"
            :no="office.tel_no || ''"
          />
        </li>
        <li class="office-data-item">
            <span v-html="$domUtils.nl2br(office.office_information)" />
        </li>
      </ul>
    </section>
    <div class="office-image-wrapper" v-if="office.portal_logo_image">
      <figure class="office-image">
        <img :src="logoUrl" alt />
      </figure>
    </div>
  </div>
</template>

<script>
import PhoneNumber from "@/components/PhoneNumber.js"

export default {
  components: {
    PhoneNumber
  },
  props: {
    office: {
      type: Object,
      required: true
    }
  },
  computed: {
    logoUrl() {
      const { portal_logo_image: logo } = this.office
      const domain = logo.split('/')[logo.indexOf('/') === 0 ? 1 : 0]
      return `https://${domain}${logo}`
    }
  },
}
</script>